import React, { useRef, useEffect, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import s from './collapse.module.css';
import Item from './item';
import { context } from './utils';
import { handleKeyPressEnter } from '../../utils/handle-keypress-enter';
import { Title, Badge, TitleAddon } from './slots';
import { containsNode } from '../../utils/dom';
var toggleEvent = function toggleEvent(payload) {
  return new CustomEvent('uikit:collapse-toggle', {
    detail: payload
  });
};
var multipleInteractions = function multipleInteractions(list, target) {
  return list.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.dataset) && 'animating' in item.dataset && !containsNode(item, target);
  }).length > 1;
};
export var Collapse = function Collapse(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'white' : _ref$variant,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'chevron' : _ref$icon,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    transparent = _ref.transparent;
  var container = useRef(null);
  var controls = useRef([]);
  var contextValue = useMemo(function () {
    return {
      icon: icon,
      size: size
    };
  }, [icon, size]);
  useEffect(function () {
    var _a;
    controls.current = Array.from(((_a = container.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(":scope > details")) || []);
  }, [children]);
  var handleClick = useCallback(function (event) {
    var target = event.target;
    var interacted = controls.current.find(function (item) {
      return containsNode(item, target);
    });
    if (!interacted || (interacted === null || interacted === void 0 ? void 0 : interacted.dataset) && 'animating' in interacted.dataset || mode === 'accordeon' && multipleInteractions(controls.current, target)) {
      return;
    }
    interacted.dispatchEvent(toggleEvent({
      event: event,
      target: target,
      artificial: false
    }));
    if (mode !== 'accordeon') {
      return;
    }
    controls.current.forEach(function (item) {
      if (item.contains(event.target) || !item.open) {
        return;
      }
      item.dispatchEvent(toggleEvent({
        event: event,
        target: target,
        artificial: true
      }));
    });
  }, [mode]);
  return React.createElement("div", {
    ref: container,
    className: classNames(s.box, s[variant], s[size], s[variant], transparent && s.transparent),
    onClick: handleClick,
    onKeyPress: handleKeyPressEnter(handleClick),
    role: "button",
    tabIndex: 0
  }, React.createElement(context.Provider, {
    value: contextValue
  }, children));
};
Collapse.Item = Item;
Collapse.Title = Title;
Collapse.Badge = Badge;
Collapse.TitleAddon = TitleAddon;